import Divider from '@/components/base/divider/divider';
import TextSkeleton from '@/components/base/skeleton/text-skeleton';
import { Link } from '@/navigation';

interface Props {
  title: string;
  url: string;
  count?: number;
}

export const Category = ({ count, url, title }: Props) => {
  return (
    <Link href={url} aria-label={title} className="block">
      <div className="flex gap-xxs py-xs">
        <p className="text-body text-default">{title}</p>
        {count && <span className="text-body text-muted">({count})</span>}
      </div>
      <Divider />
    </Link>
  );
};

const Skeleton = () => (
  <>
    <div className="my-xs flex gap-xxs">
      <TextSkeleton className="w-1/3" />
      <TextSkeleton className="w-clickable-minimum" />
    </div>
    <Divider />
  </>
);

Category.Skeleton = Skeleton;
